import {Component} from '@angular/core';
import {AnalyticsTracker} from '../../../../utils/AnalyticsTracker';

@Component({
    selector: 'app-investment-sections',
    templateUrl: './investment-sections.component.html',
    styleUrls: ['./investment-sections.component.css','../../../home/invest.component.css', '../../../../../assets/styles/new-styles.css']
})

export class InvestmentSectionComponent {
    constructor(public analyticsTracker: AnalyticsTracker) {
    }

}
